// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PxCQ","delete":"styles_delete__39Bx4","update":"styles_update__3syw9","add":"styles_add__1mwIb"};